module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/icons/quote-f05b53e93e7f3e404ffa5eb6d55d8daa.png";